import React from 'react';
import { usePermission, useRole } from '../../hooks/useAuthorization';
import { Forbidden403 } from '../../pages/Forbidden/Forbidden403';

interface ProtectedRouteProps {
  permission?: string;
  role?: string | string[];
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  permission,
  role,
  children,
}) => {
  const hasPerm = usePermission(permission || '');
  const hasRle = useRole(role || '');

  const isAllowed = (permission ? hasPerm : true) && (role ? hasRle : true);

  if (!isAllowed) {
    return <Forbidden403 />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
